import React, { useEffect, useRef } from 'react';

/**
 * Renders streamed HTML in a sandboxed srcdoc iframe.
 * Inline <style>/<script> must carry the host page CSP nonce (see injectCspNonceIntoHtml).
 */
const HTML_STREAM_SANDBOX =
  'allow-scripts allow-popups allow-modals allow-downloads';

function HtmlStreamFrame({ html, title = 'html-module', style }) {
  const iframeRef = useRef(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe || !html) {
      return;
    }
    iframe.removeAttribute('src');
    iframe.srcdoc = html;
  }, [html]);

  return (
    <iframe
      ref={iframeRef}
      title={title}
      sandbox={HTML_STREAM_SANDBOX}
      referrerPolicy="no-referrer"
      style={style}
    />
  );
}

export default React.memo(HtmlStreamFrame);
